import { useDispatch, useSelector } from 'react-redux'
import { setLocal } from '../../../../../../redux/action/local'
import props from '../../../../../../redux/props'
import Input from '../../../../../UI/Input/Input'

const HotelRooms = ({ payload, widthInPercent }) => {
  const translations = useSelector((state) => state.translations)
  const newObject = useSelector((state) => state.OBJECT)
  const dispatch = useDispatch()

  const update = (key) => (value) => {
    // dispatch(setNewObject({ ...newObject, hotelRooms: { ...newObject.hotelRooms, [key]: value } }))
    dispatch(setLocal(props.OBJECT, { ...newObject, hotelRooms: { ...newObject.hotelRooms, [key]: value } }))
  }

  return (
    <div className="wrapper" style={{ width: `${widthInPercent}%` }}>
      <div className="group">
        <div className="label">{translations['object.hotelrooms.number']}</div>
        <div className="values">
          <Input type="number" value={newObject.hotelRooms.single} onChange={update('single')} placeholder={translations['object.hotelrooms.single']} />
          <Input type="number" value={newObject.hotelRooms.double} onChange={update('double')} placeholder={translations['object.hotelrooms.double']} />
          <Input type="number" value={newObject.hotelRooms.family} onChange={update('family')} placeholder={translations['object.hotelrooms.family']} />
          <Input type="number" value={newObject.hotelRooms.junior} onChange={update('junior')} placeholder={translations['object.hotelrooms.junior']} />
          <Input type="number" value={newObject.hotelRooms.suite} onChange={update('suite')} placeholder={translations['object.hotelrooms.suite']} />
          <Input type="number" value={newObject.hotelRooms.multiBed} onChange={update('multiBed')} placeholder={translations['object.hotelrooms.multibed']} />
          <Input type="number" value={newObject.hotelRooms.apartment} onChange={update('apartment')} placeholder={translations['object.hotelrooms.apartment']} />
        </div>
      </div>
    </div>
  )
}

export default HotelRooms
